export enum DrmVendor {
    IRDETO = 'irdeto',
    DRM_TODAY = 'drmtoday',
    UNKNOWN = 'unknown'
}